import { useStyles } from '@signavio/ui';
import { utils } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = ({
  children,
  fullWidth,
  style,
  ...rest
}) => {
  const styles = useStyles(containerStyles, {
    style
  });
  const className = `container${fullWidth ? '-fluid' : ''}`;
  return /*#__PURE__*/_jsx("div", {
    ...rest,
    ...styles,
    className: className,
    children: children
  });
};
const containerStyles = {
  ...utils.media.sm({
    width: 'auto'
  })
};
export default Container;